import useAppSelector from "./useAppSelector";

// Only the admins listed on the server (core/permissions.py ADMIN_USER_EMAILS)
// may delete users, customers and accounts. The server enforces it; this only
// hides the delete buttons from everyone else.
export default function useCanDeleteAccounts() {
  return useAppSelector(
    (state) => state.user.authUser?.can_delete_accounts === true,
  );
}
